/** @format */

import { HomrProductStatsSlider } from './homr-product-stats-slider.interface';
import { HomrWireSpotCarouselSlide } from './homr-wire-spot.interface';
import { IHomrTemplateABody } from './homr-template-a-body.interface';
import { IHomrTemplateBBody } from './homr-template-b-body.interface';

export interface IHomrRichContent {
  enhancedProductCard?: HomrWireSpotCarouselSlide[];
  productStatsSlider?: HomrProductStatsSlider[];
  templateA?: IHomrTemplateABody;
  templateB?: IHomrTemplateBBody;
}
